<template>
  <div :id="navId" class="article-photo-text">
    <div class="layout">
      <div class="image-container">
        <Picture :images="images" />
      </div>
      <div v-if="heading" class="heading-container">
        <div class="type">{{ type }}</div>
        <h1 class="heading">{{ heading }}</h1>
      </div>
      <div v-if="heading" class="text-container">
        <div class="type type--desktop">{{ type }}</div>
        <div v-if="subHeading" class="article-photo-text__type">
          {{ subHeading }}
        </div>
        <h1 class="heading type--desktop">{{ heading }}</h1>
        <div class="wysiwyg" v-html="text"></div>
        <p v-if="author" class="author">Words by {{ author }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import Picture from "@/components/Picture.vue";
export default {
  name: "ArticlePhotoText",
  components: {
    Picture,
  },
  props: {
    navId: {
      type: String,
      default: null,
    },
    subHeading: {
      type: String,
      default: null,
    },
    heading: {
      type: String,
      default: null,
    },
    images: {
      type: Object,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: null,
    },
    author: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
.article-photo-text {
  display: block;
  margin: 0 auto 40px;
  max-width: 1400px;
  @include respond-above(md) {
    margin: 0 auto 80px;
  }

  &__type {
    color: #fff;
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.55px;
    margin: 0 0 10px;
    text-transform: uppercase;
  }
}

.layout {
  display: grid;
  grid-template-areas: "heading" "image" "copy";
  grid-template-columns: 1fr;
  position: relative;
  margin: 0 auto;

  @include respond-above(md) {
    display: block;
    padding: 0;
  }
}

.image-container {
  grid-area: image;
  margin: 0 0 20px 0;

  @include respond-above(md) {
    margin: 0;
  }
}

.text-container {
  grid-area: copy;
  padding: 0 20px;

  @include respond-above(md) {
    bottom: 80px;
    position: absolute;
    right: 80px;
    width: 468px;
  }
}

.heading-container {
  grid-area: heading;
  padding: 0 20px;
}

.heading {
  color: $color-grey-dark;
  @include t__editorial-headline-10;
  margin: 0 0 20px 0;

  @include respond-above(md) {
    display: none;
    font-size: 40px;
  }

  &--desktop {
    display: none;

    @include respond-above(md) {
      color: $color-white;
      display: block;
    }
  }
}

.type {
  color: $color-grey-dark;
  font-size: 9px;
  font-weight: 600;
  letter-spacing: 0.49px;
  margin: 0 0 10px 0;
  text-transform: uppercase;

  @include respond-above(md) {
    display: none;
  }

  &--desktop {
    display: none;

    @include respond-above(md) {
      color: $color-white;
      display: block;
    }
  }
}

.wysiwyg :deep() {
  color: $color-grey-dark;
  @include t__editorial-body-10;
  margin: 0 0 20px 0;

  @include respond-above(md) {
    color: $color-white;
    font-size: 18px;
  }

  h4 {
    @include t__editorial-headline-10;
    margin-bottom: 10px;

    @include respond-above(md) {
      color: $color-white;
      @include t__editorial-headline-20;
    }
  }

  p {
    margin-bottom: 20px;
  }

  *:last-child {
    margin-bottom: 0;
  }
}

.author {
  @include t__utility-label-30;
  text-align: left;

  @include respond-above(md) {
    color: $color-white;
  }
}
</style>
